<template>
    <div class="tags" v-if="showTags">
      <el-tabs v-model="tagName" type="card" closable @tab-click="selectedTabHandle" @tab-remove="removeTab">
        <el-tab-pane
          v-for="(item) in tagsList"
          :key="item.path"
          :label="item.meta.title"
          :name="item.path"
        >
          {{item.title}}
        </el-tab-pane>
      </el-tabs>
        <!-- <ul class="clearfix">
            <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}" :key="index">
                <router-link :to="item.path" :title="item.title" class="tags-li-title">
                    {{item.title}}
                </router-link>
                <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
            </li>
        </ul> -->
        <div class="tags-close-box">
            <el-dropdown @command="handleTags">
                <el-button size="small " type="primary">
                    标签选项<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu size="small" slot="dropdown">
                    <el-dropdown-item command="other">关闭其他</el-dropdown-item>
                    <el-dropdown-item command="all">关闭所有</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      tagsList: [],
      tagName: ''
      // showTags: true
    }
  },
  methods: {
    isActive (path) {
      return path === this.$route.fullPath
    },
    removeTab (tab) {
      let index = ''
      this.tagsList.forEach((v, i) => {
        if (v.path === tab) {
          index = i
          this.closeTags(index)
        }
      })
    },
    selectedTabHandle (tab) {
      let selectTab = this.tagsList.filter(item => item.path === tab.name)
      if (selectTab.length >= 1) {
        this.$router.replace({path: selectTab[0].fullPath})
      }
    },
    // 关闭单个标签
    closeTags (index) {
      const delItem = this.tagsList.splice(index, 1)[0]
      this.$emit('reletedCusGroup', this.tagsList)
      const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1]
      console.log(delItem)
      console.log(this.tagsList)
      // if (this.$route.meta.keepAlive) {
      //   console.log(this.$route.meta.keepAlive)
      //   this.$route.meta.keepAlive = false
      // }
      if (item) {
        delItem.path === this.$route.path && this.$router.push(item.fullPath)
      } else {
        this.$router.push('/')
      }
    },
    // 关闭全部标签
    closeAll () {
      this.tagsList = []
      this.$emit('reletedCusGroup', this.tagsList)
      this.$router.push('/')
    },
    // 关闭其他标签
    closeOther () {
      const curItem = this.tagsList.filter(item => {
        return item.fullPath === this.$route.fullPath
      })
      this.tagsList = curItem
      this.$emit('reletedCusGroup', this.tagsList)
    },
    // 设置标签
    setTags (route) {
      const isExist = this.tagsList.some(item => {
        return item.path === route.path
      })
      console.log(route)
      if (!isExist) {
        // if (this.tagsList.length >= 16) {
        //   this.tagsList.shift()
        // }
        if (!route.matched[1]) return // 防止主路由出现
        // for (let v of this.tagsList) {
        //   if (v.path === route.fullPath) {
        //     return
        //   }
        // }
        this.tagsList.push(route)
      } else {
        for (let i = 0; i < this.tagsList.length; i++) {
          if (this.tagsList[i].path === route.path) {
            this.tagsList[i] = route
          }
        }
      }
      if (this.tagName !== route.path) {
        this.tagName = route.path // 高亮当前路由
      }
      // console.log(this.tagsList)
      this.$emit('reletedCusGroup', this.tagsList)
    },
    handleTags (command) {
      command === 'other' ? this.closeOther() : this.closeAll()
    }
  },
  computed: {
    showTags () {
      return this.tagsList.length > 0
    },
    closeTab () {
      return this.$store.state.closeTab
    }
  },
  watch: {
    $route (newValue, oldValue) {
      console.log(newValue)
      this.$store.dispatch('changeRoute', newValue)
      this.setTags(newValue)
      // if (newValue.meta.keepAlive === false) {
      //   if (newValue.path === '/addMaintenance') {
      //     this.$route.meta.keepAlive = true
      //   }
      // }
    },
    closeTab (newValue, oldValue) {
      if (newValue) {
        this.removeTab(newValue.path)
      }
    },
    tagName (newValue, oldValue) {
      // this.$router.push(newValue)
    }
  },
  created () {
    this.setTags(this.$route)
    // 监听关闭当前页面的标签页
    this.$root.eventHub.$on('cloose', () => {
      console.log('ss')
      // for (let i = 0, len = this.tagsList.length; i < len; i++) {
      //   const item = this.tagsList[i]
      //   if (item.path === this.$route.fullPath) {
      //     if (i < len - 1) {
      //       this.$router.push(this.tagsList[i + 1].path)
      //     } else if (i > 0) {
      //       this.$router.push(this.tagsList[i - 1].path)
      //     } else {
      //       this.$router.push('/')
      //     }
      //     this.tagsList.splice(i, 1)
      //   }
      // }
    })
  }
}
</script>
<style>
 .clearfix:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    line-height: 0;
    overflow: hidden;
}
    .tags {
        position: relative;
        height: 40px;
        overflow: hidden;
        background: #fff;
        padding: 0 120px 0 10px;
        box-shadow: 0 5px 10px #ddd;
    }
    .tags ul {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }
    .tags-li {
        float: left;
        margin: 5px 5px 2px 3px;
        border-radius: 3px;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;
        height: 28px;
        line-height: 28px;
        border: 1px solid #e9eaec;
        background: #fff;
        padding: 0 10px 0 18px;
        vertical-align: middle;
        color: #666;
        -webkit-transition: all .3s ease-in;
        -moz-transition: all .3s ease-in;
        transition: all .3s ease-in;
    }
    .tags-li:not(.active):hover {
        background: #f8f8f8;
    }
    .tags-li.active {
        color: #fff;
        border: 1px solid #409eff;
        background-color: #409eff;
    }
    .tags-li-title {
        float: left;
        max-width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: #666;
        text-decoration: none;
    }
    .tags-li.active .tags-li-title {
        color: #fff;
    }
    .tags-close-box {
        position: absolute;
        right: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 1px;
        text-align: center;
        width: 110px;
        height: 40px;
        background: #fff;
        box-shadow: -3px 0 15px 3px rgba(0, 0, 0, .1);
        z-index: 10;
        padding-top: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/views/tab/Tags.vue